const isNullCheck = (value) =>
  typeof value !== 'undefined' && value !== null && value !== '';
export default isNullCheck;
